<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.departmentacccycle_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/department/departmentacccycle';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '住户信息ID',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入住户信息ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '会计周期',
            prop: 'accountCycle',
            rules: [
              {
                required: true,
                message: '请输入会计周期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区ID',
            prop: 'communityId',
            rules: [
              {
                required: true,
                message: '请输入小区ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区名称',
            prop: 'communityName',
            rules: [
              {
                required: true,
                message: '请输入小区名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开始日期(统计是包含改日期)',
            prop: 'startDate',
            rules: [
              {
                required: true,
                message: '请输入开始日期(统计是包含改日期)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '结束日期(统计是不包含改日期)',
            prop: 'endDate',
            rules: [
              {
                required: true,
                message: '请输入结束日期(统计是不包含改日期)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开账标识，0.未开账，1.已开账',
            prop: 'openFlag',
            rules: [
              {
                required: true,
                message: '请输入开账标识，0.未开账，1.已开账',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开账时间',
            prop: 'openDate',
            rules: [
              {
                required: true,
                message: '请输入开账时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否扎帐  0.为扎帐，1.已扎帐',
            prop: 'settleFlag',
            rules: [
              {
                required: true,
                message: '请输入是否扎帐  0.为扎帐，1.已扎帐',
                trigger: 'change',
              },
            ],
          },
          {
            label: '扎帐日期',
            prop: 'settleDate',
            rules: [
              {
                required: true,
                message: '请输入扎帐日期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区欠费扎帐',
            prop: 'xqqfFlag',
            rules: [
              {
                required: true,
                message: '请输入小区欠费扎帐',
                trigger: 'change',
              },
            ],
          },
          {
            label: '银行代扣扎帐',
            prop: 'yhdkFlag',
            rules: [
              {
                required: true,
                message: '请输入银行代扣扎帐',
                trigger: 'change',
              },
            ],
          },
          {
            label: '在线支付扎帐',
            prop: 'zxzfFlag',
            rules: [
              {
                required: true,
                message: '请输入在线支付扎帐',
                trigger: 'change',
              },
            ],
          },
          {
            label: '现金缴费扎帐',
            prop: 'xjjfFlag',
            rules: [
              {
                required: true,
                message: '请输入现金缴费扎帐',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注1',
            prop: 'remark1',
            rules: [
              {
                required: true,
                message: '请输入备注1',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注2',
            prop: 'remark2',
            rules: [
              {
                required: true,
                message: '请输入备注2',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注3',
            prop: 'remark3',
            rules: [
              {
                required: true,
                message: '请输入备注3',
                trigger: 'change',
              },
            ],
          },
          {
            label: '版本',
            prop: 'version',
            rules: [
              {
                required: true,
                message: '请输入版本',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.departmentacccycle_add, false),
        viewBtn: this.vaildData(this.permission.departmentacccycle_view, false),
        delBtn: this.vaildData(this.permission.departmentacccycle_delete, false),
        editBtn: this.vaildData(this.permission.departmentacccycle_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
